import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from '../../../core/constants/global-constants.constant';
import { LocalStorageService } from '../../../core/services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class MSDCService {

  baseUrl: string = `${environment.logisticsApiUrl}/msdc`;

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) { }

  get language(): string {
    return this.localStorageService.getItem(GlobalConstants.languageKey);
  }

  updateMSDCData(params:any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/msdc/updateMSDCData`;
    return this.http.post(url,params);
  }

  queryMSDCData(params:any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/msdc/queryMSDCData`;
    return this.http.post(url,params);
  }

  exportMSDCExcel(request: any): Observable<any> {
    const url = this.baseUrl + `/exportMSDCExcel/` + this.language;
    console.log('check language',this.language)
    return this.http.post(url, request, { responseType: 'blob' });
  }
}
